/// <amd-module name="VSS/Redux/Modules/Navigation/NavigationContracts" />
export interface INavigationAwareState {
    navigationState: INavigationState;
}

export interface INavigationState {
    isNavigating: boolean;
}
